import React from 'react';
import PropTypes from 'prop-types';
import SupplyTricolorDot from './SupplyTricolorDot';
import SupplyDot from './SupplyDot';

const Dot = ({ code }) => {
  if (code === 'CMY') {
    return <SupplyTricolorDot key={code} />;
  }
  return (
    <SupplyDot
      key={code}
      colorCode={code}
    />
  );
};

Dot.propTypes = {
  code: PropTypes.string.isRequired
};

export default Dot;
